import React from "react"
import {
    Avatar,
    Button,
    FormControl,
    FormLabel,
    IconButton,
    Popover,
    PopoverArrow,
    PopoverBody,
    PopoverCloseButton,
    PopoverContent,
    PopoverTrigger,
    SimpleGrid,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs
} from "@chakra-ui/react"
import {CatIcon} from "@components/app"
import {colorList, iconList} from "@components/common"
import {IconNameExt} from "@utils/icons"

type FIconColorPickerProps = {
    register?: any
    errors?: any
    icon: {
        parentField?: string,
        field: string,
        setValue: (name: string, value: unknown, config?: Object) => void,
        value?: any
        rules?: any;
    },
    color: {
        parentField?: string,
        field: string,
        setValue: (name: string, value: unknown, config?: Object) => void,
        value?: any
        rules?: any;
    },
}

export function FIconColorPicker(props: FIconColorPickerProps) {
    const {
        icon,
        color,
        register,
        errors
    } = props

    register(icon.field, icon.rules)
    register(color.field, color.rules)


    return <FormControl>
        <FormLabel>Icon & Color</FormLabel>
        <Popover placement="bottom-start">
            <PopoverTrigger>
                <IconButton
                    rounded="full"
                    aria-label="" icon={<Avatar
                    bg={color.value}
                    icon={<CatIcon icon={icon.value || "blender"} iconSize="lg"/>}/>}/>
            </PopoverTrigger>
            <PopoverContent>
                <PopoverArrow/>
                <PopoverBody p={0}>
                    <Tabs>
                        <TabList>
                            <Tab>Icon</Tab>
                            <Tab>Color</Tab>
                            <PopoverCloseButton/>
                        </TabList>
                        <TabPanels>
                            <TabPanel>
                                <SimpleGrid columns={6} spacing={1}>
                                    {iconList.map(({label, value, element}) =>
                                        <IconButton
                                            key={value}
                                            onClick={() => {
                                                icon.setValue(icon.field, value)
                                                //onClose()
                                            }}
                                            aria-label="icon" variant="outline"
                                            icon={<CatIcon icon={value as IconNameExt} iconSize="lg"/>}/>
                                    )}
                                </SimpleGrid>
                            </TabPanel>
                            <TabPanel>
                                <SimpleGrid columns={5} spacing={1}>
                                    {colorList.map(({label, value, element}) =>
                                        <Button
                                            key={value}
                                            _hover={{opacity: 0.6}}
                                            onClick={() => {
                                                color.setValue(color.field, value)
                                                //onClose()
                                            }}
                                            bg={value}
                                            aria-label="icon" variant="solid"/>
                                    )}
                                </SimpleGrid>
                            </TabPanel>
                        </TabPanels>
                    </Tabs>
                </PopoverBody>
            </PopoverContent>
        </Popover>
    </FormControl>
}

